import React from 'react';
import { withLocale } from '../hocs/withLocale';
import routes from 'library/Routes';

export const TermsAndConditions = withLocale(({ currentLanguage }) => {
  switch (currentLanguage) {
    case 'uk_UA':
      return (
        <div style={{ margin: 10 }}>
          <h1>ДОГОВІР про надання консультаційних послуг з питань інформатизації, послуг з оброблення даних №</h1>
          Фізична або юридична особа, що діє на підставі держаної реєстрації в реєстрі юридичних осіб, фізичних
          осіб-підприємців та громадських формувань, іменована надалі «Замовник», з одного боку, та Фізична особа –
          підприємець Холодова Таісія Володимирівна, що діє на підставі держаної реєстрації в реєстрі юридичних осіб,
          фізичних осіб-підприємців та громадських формувань, дата та номер запису 03.10.2018 року, 2 480 000 0000
          215623, іменована надалі «Виконавець», з іншого боку, надалі разом іменовані «Сторони», а кожен окремо
          «Сторона», уклали цей Договір про надання консультаційних послуг з питань інформатизації, послуг з оброблення
          даних № від «» 20 року (надалі – «Договір») про наступне:
          <h3>1. ПРЕДМЕТ ДОГОВОРУ</h3>
          <ul>
            <li>
              1.1. Виконавець зобов’язується за надати консультаційні послуги з питань інформатизації та/або послуги з
              оброблення даних, визначені в п. 1.2. Договору (надалі – Послуги), в порядку та на умовах, встановлених
              цим Договором, а Замовник зобов’язується прийняти надані Послуги та оплатити їх в порядку та на умовах,
              встановлених цим Договором.
            </li>
            <li>
              1.2. За цим Договором Виконавець надає наступні Послуги: консультаційні послуги з питань інформатизації, а
              саме: консультування щодо типів та конфігурації комп’ютерних засобів та аналіз інформаційних потреб
              користувачів та пошук найоптимальніших рішень, тощо; послуги з оброблення даних, а саме: підготовка даних
              для збору; спеціалізовані роботи у сфері введення даних, перетворення файлів, відновлення даних, оптичне
              збирання даних, розміщення даних у мережі Інтернет, тощо.
            </li>
          </ul>
          <h3>2. ПОРЯДОК РОЗРАХУНКІВ.</h3>
          <ul>
            <li>
              2.1. Ціна Договору складається із суми всіх виплат, здійснених Замовником на користь Виконавця за цим
              Договором протягом усього строку його дії.{' '}
              <a href="https://landing.voopty.com.ua/tariffs/" target="_blank" rel="noopener noreferrer">
                Інформація про ціни
              </a>
            </li>
            <li>
              2.2. За надання послуг згідно з цим Договором, Замовник виплачує Виконавцю винагороду, розмір якої
              вказується у відповідному Рахунку-фактурі та/або Акті приймання-передачі наданих послуг.
            </li>
            <li>
              2.2.1. Вартість послуг може бути переглянута за домовленістю Сторін у зв'язку із збільшенням (зменшенням)
              об’ємів послуг.
            </li>
            <li>
              2.3. Замовник здійснює оплату Послуг протягом 10 (десяти) календарних днів після отримання відповідного
              Рахунку-фактурі та/або Акті приймання-передачі наданих послуг, якщо інше не передбачено Сторонами у
              відповідному Додатку та/або Додатковій угоді до цього Договору.
            </li>
            <li>
              2.4. Оплата Послуг здійснюється Замовником шляхом безготівкового перерахування відповідної суми грошових
              коштів на поточний рахунок Виконавця, вказаний в статті 12 цього Договору, якщо інше не передбачено
              Сторонами у відповідному Додатку та/або Додатковій угоді до цього Договору.
            </li>
            <li>2.5. Всі розрахунки за цим Договором здійснюються в національній валюті України – гривні.</li>
          </ul>
          <h3>3. ОСОБЛИВОСТІ НАДАННЯ ПОСЛУГ.</h3>
          <ul>
            <li>
              3.1. Виконавець надає Послуги за цим Договором особисто. Треті особи можуть залучатись Виконавцем до
              виконання Послуг за цим Договором лише за умови попереднього погодження такого залучення із Замовником.
              При цьому Виконавець несе повну відповідальність за неналежне надання та/або ненадання Послуг такими
              третіми особами у випадку їх залучення.
            </li>
            <li>
              3.2. За необхідності, Виконавець отримує необхідну інформацію, документацію та інше для надання Послуг в
              приміщенні/офісі (на території) Замовника. Замовник має право надавати Виконавцеві необхідну інформацію,
              документацію та інше за допомогою електронної пошти та/або шляхом надання доступу Виконавцеві до
              комп‘ютерів, серверів, інших ресурсів Замовника та/або третіх.
            </li>
            <li>
              3.3. Замовник має право надавати Виконавцеві доступ до комп‘ютерів, серверів Замовника та/або третіх осіб
              (у випадках якщо заборона надання такого доступу не передбачена договорами укладеними Замовником із
              відповідними третіми особами) для виконання останнім своїх обов‘язків за Договором.
            </li>
            <li>
              3.4. Замовник має право в будь-який час перевіряти хід і якість надання Послуг Виконавцем, не втручаючись
              при цьому в його діяльність.
            </li>
          </ul>
          <h3>4. ПРИЙМАННЯ-ПЕРЕДАЧА НАДАНИХ ПОСЛУГ.</h3>
          <ul>
            <li>
              4.1. Приймання-передача наданих Послуг здійснюється за Актом приймання-передачі наданих послуг, який
              складається 1 (один) раз на 3 (три) місяці.
            </li>
            <li>
              4.2. За необхідності, приймання-передача наданих послуг здійснюється в приміщенні/офісі (на території) та
              на обладнанні Замовника.
            </li>
            <li>
              4.3. Акти приймання-передачі наданих послуг підписуються протягом 10 (десяти) календарних днів з дня
              закінчення надання відповідних Послуг, в якому такі Послуги були надані.
            </li>
            <li>
              4.4. По закінченню надання Послуг Виконавець надає Замовнику два примірники Акту приймання-передачі
              наданих послуг, які Замовник повинен підписати та повернути один примірник Виконавцеві протягом 10
              (десяти) календарних днів з дня їх отримання.
            </li>
            <li>
              4.5. Підписання Акту здачі-приймання наданих послуг представником Замовника є підтвердженням належного
              надання послуг і відсутності претензій з його боку до Виконавця.
            </li>
            <li>
              4.6. Якщо під час приймання-передачі наданих Послуг буде виявлена їх невідповідність вимогам цього
              Договору, вимогам відповідного технічного завдання тощо, Замовник у строк, передбачений п. 4.3. Договору,
              надає Виконавцеві вмотивовану відмову від підписання Акту приймання-передачі наданих послуг із зазначенням
              переліку необхідних доопрацювань і строку їх усунення.
            </li>
            <li>
              4.7. В Акті приймання-передачі зазначається конкретний перелік, тривалість та вартість наданих Послуг.
            </li>
          </ul>
          <h3>5. ПРАВА ТА ОБОВ’ЯЗКИ СТОРІН</h3>
          <p>5.1. Замовник зобов‘язаний:</p>
          <ul>
            <li>
              5.1.1. Надати Виконавцеві всю необхідну інформацію, документацію та інше для надання Послуг за цим
              Договором.
            </li>
            <li>
              5.1.2. Прийняти та оплатити належним чином надані Виконавцем Послуги в порядку та на умовах, передбачених
              Договором.
            </li>
            <li>
              5.1.3. Замовник може нести інші обов‘язки, передбачені цим Договором та/або чинним законодавством України.
            </li>
          </ul>
          <p> 5.2. Замовник має право:</p>
          <ul>
            <li>
              5.2.1. Перевіряти хід і якість Послуг, що надаються за цим Договором, не втручаючись в діяльність
              Виконавця.
            </li>
            <li>
              5.2.2. Замовник може мати інші права, передбачені цим Договором та/або чинним законодавством України.
            </li>
          </ul>
          <p>5.3. Виконавець зобов‘язаний:</p>
          <ul>
            <li>
              5.3.1. Надавати Послуги за цим Договором якісно, своєчасно, належним чином, в порядку та на умовах,
              передбачених Договором.
            </li>
            <li>
              5.3.2. У встановлений цим Договором строк надавати Замовнику Акти приймання-передачі наданих послуг,
              складені у відповідності до вимог цього Договору.
            </li>
            <li>
              5.3.3. На письмову та/або усну вимогу Замовника негайно інформувати Замовника про хід надання Послуг.
            </li>
            <li>
              5.3.4. Не передавати будь-яким третім особам, не оприлюднювати та не використовувати у власних цілях (в
              тому числі, але не обмежуючись, у своїй підприємницькій діяльності) всю та будь-яку інформацію про
              Замовника, умови цього Договору, Послуги, що надаються за цим Договором тощо, яка була одержана у зв‘язку
              та/або під час укладання та/або виконання цього Договору.
            </li>
            <li>
              5.3.5. Протягом трьох календарних днів з дня завершення надання відповідних Послуг повернути Замовнику все
              одержане від останнього для надання таких Послуг, а саме: будь-яке майно, в тому числі технічні засоби,
              апаратуру, обладнання тощо, документацію, інформацію тощо.
            </li>
            <li>
              5.3.6. Дотримуватись вимог чинного законодавства України в сфері охорони прав інтелектуальної власності.
            </li>
            <li>
              5.3.7. Відшкодовувати завдані Замовнику збитки в повному обсязі відповідно до вимог чинного законодавства
              України та цього Договору.
            </li>
            <li>
              5.3.9. Виконавець може нести інші обов‘язки, передбачені цим Договором та/або чинним законодавством
              України.
            </li>
          </ul>
          <p>5.4. Виконавець має право:</p>
          <ul>
            <li>5.4.1. На своєчасну та повну оплату належним чином наданих Послуг.</li>
            <li>
              5.4.2. Виконавець може мати інші права, передбачені цим Договором та/або чинним законодавством України.
            </li>
          </ul>
          <h3>6. ВІДПОВІДАЛЬНІСТЬ СТОРІН.</h3>
          <ul>
            <li>
              6.1. За невиконання та/або неналежне виконання своїх обов‘язків за цим Договором Сторони несуть
              відповідальність, визначену Договором та чинним законодавством України.
            </li>
            <li>
              6.2. За несвоєчасну оплату належним чином наданих Послуг Замовник сплачує на користь Виконавця пеню у
              розмірі подвійної облікової ставки НБУ, що діяла в період, за який сплачується пеня, від несвоєчасно
              сплаченої суми за кожен день затримки розрахунків.
            </li>
            6.3. Сторона, що порушила свої зобов‘язання за цим Договором, відшкодовує іншій Стороні збитки, завдані
            таким порушенням, в повному обсязі, включаючи упущену вигоду.
            <li>6.4. Збитки за цим Договором відшкодовуються понад сплату санкцій.</li>
            <li>
              6.5. Сплата санкцій та/або відшкодування збитків не звільняє Сторони від виконання своїх зобов‘язань за
              Договором.
            </li>
          </ul>
          <h3>7. ЗБЕРЕЖЕННЯ КОМЕРЦІЙНОЇ ТАЄМНИЦІ ТА КОНФІДЕНЦІЙНОЇ ІНФОРМАЦІЇ.</h3>
          <ul>
            <li>
              7.1. Сторони зобов'язуються не передавати третім особам конфіденційну інформацію, до якої вони віднесли
              будь-яку інформацію про їхню діяльність, умови цього Договору, Послуги, що надаються за цим Договором
              тощо, отриману при укладенні та виконанні цього Договору або у зв‘язку з цим.
            </li>
            <li>
              7.2. Сторони домовились, що текст Договору (крім випадків, прямо передбачених чинним законодавством
              України), вихідні дані для надання Послуг та результати наданих Послуг, будь-які дані та інформація,
              документація, що передані Виконавцю та/або створені Виконавцем при виконанні Договору, виражені у формі:
              документ, інформація тощо є конфіденційними та складають комерційну таємницю Замовника та за будь-яких
              умов не підлягає розголошенню Виконавцем. Передача Стороною третім особам даних, що складають
              конфіденційну інформацію, дозволяється лише зі згоди іншої Сторони, за винятком випадків, коли вимога про
              її надання пред'явлена компетентним органом у відповідності до чинного законодавства України.
            </li>
            <li>
              7.3. Умови про не передання конфіденційної інформації зберігають свою силу протягом строку дії Договору.
            </li>
            <li>
              7.4. Інформація не вважається конфіденційною, якщо вона відповідає хоча б одній із таких умов: - вже була
              відома Виконавцеві до укладання Договору; - отримана легально від третьої особи поза зв’язком з цим
              Договором; - розкрита публічно самим Замовником; - розкрита за обґрунтованою письмовою вимогою державного
              органу, повноваження якого щодо отримання такої інформації, визначені чинним законодавством України; -
              дозволена до розповсюдження з письмової згоди Замовника.
            </li>
            <li>
              7.5. У кожному зазначеному у п. 7.4 Договору випадку Виконавець повинен надати Замовнику письмові
              пояснення по кожному випадку оприлюднення, передачі чи витоку інформації з документальним підтвердженням
              правомірності своїх дій протягом 10 (десяти) календарних днів з дня надходження письмового запиту від
              Замовника.
            </li>
            <li>
              7.6. Виконавець гарантує збереження конфіденційності особисто. Відомості, що складають комерційну таємницю
              в будь-якій формі, можуть бути передані третім особам винятково за попередньою письмовою згодою Замовника.
            </li>
            <li>
              7.7. У випадку залучення Виконавцем до надання Послуг третіх осіб, він гарантує, що з переданою
              документацією та інформацією будуть ознайомлені тільки ті особи, що безпосередньо пов'язані із наданням
              Послуг за Договором. Перелік таких осіб погоджується Виконавцем із Замовником.
            </li>
            <li>
              7.8. У випадку розголошення Виконавцем та/або залученими ним до виконання цього Договору третіми особами,
              їхніми працівниками конфіденційної інформації та/або комерційної таємниці, Виконавець зобов‘язується
              відшкодувати Замовнику всі завдані таким розголошенням збитки в повному обсязі , а також сплатити
              передбачену статтею 7 цього Договору.
            </li>
          </ul>
          <h3>8. ФОРС-МАЖОР.</h3>
          <ul>
            <li>
              8.1. Сторони звільняються від відповідальності за часткове та/або повне невиконання зобов’язань за
              Договором, якщо воно є наслідком обставин непереборної сили та/або їх наслідків, а саме: пожежі, повені,
              землетрусу, диверсії, військових дій та/або зміни законодавства, якщо ці обставини та/або їх наслідки
              безпосередньо вплинули на виконання договірних зобов'язань Сторонами. При цьому строк виконання
              зобов'язань продовжується на час, протягом якого діяли такі обставини.
            </li>
            <li>
              8.2. Якщо обставини непереборної сили та/або їх наслідки будуть тривати більше тридцяти календарних днів,
              то кожна зі Сторін має право в односторонньому порядку розірвати Договір, і в цьому випадку жодна із
              Сторін не матиме права на відшкодування збитків.
            </li>
            <li>
              8.3. Сторона, яка не в змозі виконати свої зобов'язання за Договором внаслідок дії обставин непереборної
              сили та/або їх наслідків, зобов'язана негайно письмово повідомити іншу Сторону про початок і припинення
              дії зазначених обставин та/або їх наслідків, підтвердивши довідками компетентних органів країни, в якій
              обставини непереборної сили та/або їх наслідки мали місце, але в будь-якому випадку не пізніше 10 (десяти)
              календарних днів з дня їх виникнення. Несвоєчасне повідомлення про обставини непереборної сили та/або їх
              наслідки позбавляє відповідну Сторону права на звільнення від зобов'язань за Договором з причини
              зазначених обставин та/або їх наслідків.
            </li>
          </ul>
          <h3>9. ВИРІШЕННЯ СПОРІВ.</h3>
          <ul>
            <li>
              9.1. Усі спори, що виникають з цього Договору або пов'язані із ним, вирішуються шляхом переговорів між
              Сторонами.
            </li>
            <li>
              9.2. Якщо відповідний спір неможливо вирішити шляхом переговорів, він вирішується в судовому порядку за
              встановленою підвідомчістю та підсудністю такого спору відповідно до чинного законодавства України.
            </li>
          </ul>
          <h3>10. СТРОК ДІЇ ДОГОВОРУ.</h3>
          <ul>
            <li>10.1. Цей Договір набирає чинності з дня його підписання Сторонами і діє до «» 20 року.</li>
            <li>
              10.2. Строк дії Договору може бути продовжений на наступний календарний рік, якщо жодна Сторона не
              повідомила про його припинення іншу Сторону за 30 (тридцять) календарних днів до закінчення строку дії
              Договору.
            </li>
            <li>10.3. Договір може бути припинений за згодою Сторін.</li>
            <li>
              10.4. У випадку припинення Договору з будь-яких підстав, в тому числі через закінчення строку дії
              Договору, дострокове розірвання тощо, Виконавець зобов’язаний повернути Замовнику все обладнання,
              матеріали та інше майно (або грошові кошти), отримані для надання Послуг за цим Договором. Електронні
              копії (примірники) документації, які так чи інакше використовувались для надання Послуг за цим Договором,
              що містяться на електронних носіях, що належать Виконавцеві, Виконавець зобов‘язаний знищити протягом
              трьох календарних днів з дня припинення Договору.
            </li>
            <li>
              10.5. Кожна із Сторін має розірвати Договір в односторонньому порядку, сповістивши про це одна одну
              письмово за 30 (тридцять) календарних днів до дня розірвання Договору.
            </li>
          </ul>
          <h3>11. ІНШІ УМОВИ.</h3>
          <ul>
            <li>
              11.1. Сторона несе повну відповідальність за правильність вказаних нею у цьому Договорі реквізитів та
              інших даних і зобов'язується протягом 10 (десяти) календарних днів з дня їх зміни у письмовій формі
              повідомляти іншу Сторону про таку зміну, а у разі неповідомлення несе ризик настання пов'язаних із цим
              несприятливих наслідків.
            </li>
            <li>
              11.2. Після укладення цього Договору всі попередні переговори за ним, листування, попередні договори,
              протоколи про наміри та будь-які інші усні або письмові домовленості Сторін з питань, що так чи інакше
              стосуються цього Договору, втрачають юридичну силу.
            </li>
            <li>
              11.3. Зміни до цього Договору можуть бути внесені за взаємною згодою Сторін, що оформляється Додатковою
              угодою до цього Договору.
            </li>
            <li>
              11.4. Додаткові угоди та Додатки до цього Договору є його невід'ємними частинами і мають юридичну силу у
              випадку, якщо вони викладені у письмовій формі та підписані Сторінами.
            </li>
            <li>
              11.5. Недійсність окремих положень цього Договору не тягне недійсність Договору в цілому, оскільки можна
              припустити, що цей Договір міг би бути укладений без включення до нього таких положень.
            </li>
            <li>
              11.6. Назви розділів цього Договору використовуються лише для зручності та жодним чином не впливають на їх
              зміст і тлумачення.
            </li>
            <li>11.7. Замовник є платником єдиного податку.</li>
            <li>11.8. Виконавець є платником єдиного податку.</li>
            <li>
              11.9. Цей Договір складений при повному розумінні Сторонами його умов та термінології українською мовою у
              двох автентичних примірниках, які мають однакову юридичну силу, - по одному для кожної із Сторін.
            </li>
            <li>11.10. Підписання цього Договору є свідченням повного розуміння Сторонами його предмету та умов.</li>
          </ul>
        </div>
      );
    case 'ru_UA':
      return (
        <div style={{ margin: 10 }}>
          <h1>ДОГОВІР про надання консультаційних послуг з питань інформатизації, послуг з оброблення даних №</h1>
          Фізична або юридична особа, що діє на підставі держаної реєстрації в реєстрі юридичних осіб, фізичних
          осіб-підприємців та громадських формувань, іменована надалі «Замовник», з одного боку, та Фізична особа –
          підприємець Холодова Таісія Володимирівна, що діє на підставі держаної реєстрації в реєстрі юридичних осіб,
          фізичних осіб-підприємців та громадських формувань, дата та номер запису 03.10.2018 року, 2 480 000 0000
          215623, іменована надалі «Виконавець», з іншого боку, надалі разом іменовані «Сторони», а кожен окремо
          «Сторона», уклали цей Договір про надання консультаційних послуг з питань інформатизації, послуг з оброблення
          даних № від «» 20 року (надалі – «Договір») про наступне:
          <h3>1. ПРЕДМЕТ ДОГОВОРУ</h3>
          <ul>
            <li>
              1.1. Виконавець зобов’язується за надати консультаційні послуги з питань інформатизації та/або послуги з
              оброблення даних, визначені в п. 1.2. Договору (надалі – Послуги), в порядку та на умовах, встановлених
              цим Договором, а Замовник зобов’язується прийняти надані Послуги та оплатити їх в порядку та на умовах,
              встановлених цим Договором.
            </li>
            <li>
              1.2. За цим Договором Виконавець надає наступні Послуги: консультаційні послуги з питань інформатизації, а
              саме: консультування щодо типів та конфігурації комп’ютерних засобів та аналіз інформаційних потреб
              користувачів та пошук найоптимальніших рішень, тощо; послуги з оброблення даних, а саме: підготовка даних
              для збору; спеціалізовані роботи у сфері введення даних, перетворення файлів, відновлення даних, оптичне
              збирання даних, розміщення даних у мережі Інтернет, тощо.
            </li>
          </ul>
          <h3>2. ПОРЯДОК РОЗРАХУНКІВ.</h3>
          <ul>
            <li>
              2.1. Ціна Договору складається із суми всіх виплат, здійснених Замовником на користь Виконавця за цим
              Договором протягом усього строку його дії.
              <a href="https://landing.voopty.com.ua/tariffs/" target="_blank" rel="noopener noreferrer">
                Информация про цены
              </a>
            </li>
            <li>
              2.2. За надання послуг згідно з цим Договором, Замовник виплачує Виконавцю винагороду, розмір якої
              вказується у відповідному Рахунку-фактурі та/або Акті приймання-передачі наданих послуг.
            </li>
            <li>
              2.2.1. Вартість послуг може бути переглянута за домовленістю Сторін у зв'язку із збільшенням (зменшенням)
              об’ємів послуг.
            </li>
            <li>
              2.3. Замовник здійснює оплату Послуг протягом 10 (десяти) календарних днів після отримання відповідного
              Рахунку-фактурі та/або Акті приймання-передачі наданих послуг, якщо інше не передбачено Сторонами у
              відповідному Додатку та/або Додатковій угоді до цього Договору.
            </li>
            <li>
              2.4. Оплата Послуг здійснюється Замовником шляхом безготівкового перерахування відповідної суми грошових
              коштів на поточний рахунок Виконавця, вказаний в статті 12 цього Договору, якщо інше не передбачено
              Сторонами у відповідному Додатку та/або Додатковій угоді до цього Договору.
            </li>
            <li>2.5. Всі розрахунки за цим Договором здійснюються в національній валюті України – гривні.</li>
          </ul>
          <h3>3. ОСОБЛИВОСТІ НАДАННЯ ПОСЛУГ.</h3>
          <ul>
            <li>
              3.1. Виконавець надає Послуги за цим Договором особисто. Треті особи можуть залучатись Виконавцем до
              виконання Послуг за цим Договором лише за умови попереднього погодження такого залучення із Замовником.
              При цьому Виконавець несе повну відповідальність за неналежне надання та/або ненадання Послуг такими
              третіми особами у випадку їх залучення.
            </li>
            <li>
              3.2. За необхідності, Виконавець отримує необхідну інформацію, документацію та інше для надання Послуг в
              приміщенні/офісі (на території) Замовника. Замовник має право надавати Виконавцеві необхідну інформацію,
              документацію та інше за допомогою електронної пошти та/або шляхом надання доступу Виконавцеві до
              комп‘ютерів, серверів, інших ресурсів Замовника та/або третіх.
            </li>
            <li>
              3.3. Замовник має право надавати Виконавцеві доступ до комп‘ютерів, серверів Замовника та/або третіх осіб
              (у випадках якщо заборона надання такого доступу не передбачена договорами укладеними Замовником із
              відповідними третіми особами) для виконання останнім своїх обов‘язків за Договором.
            </li>
            <li>
              3.4. Замовник має право в будь-який час перевіряти хід і якість надання Послуг Виконавцем, не втручаючись
              при цьому в його діяльність.
            </li>
          </ul>
          <h3>4. ПРИЙМАННЯ-ПЕРЕДАЧА НАДАНИХ ПОСЛУГ.</h3>
          <ul>
            <li>
              4.1. Приймання-передача наданих Послуг здійснюється за Актом приймання-передачі наданих послуг, який
              складається 1 (один) раз на 3 (три) місяці.
            </li>
            <li>
              4.2. За необхідності, приймання-передача наданих послуг здійснюється в приміщенні/офісі (на території) та
              на обладнанні Замовника.
            </li>
            <li>
              4.3. Акти приймання-передачі наданих послуг підписуються протягом 10 (десяти) календарних днів з дня
              закінчення надання відповідних Послуг, в якому такі Послуги були надані.
            </li>
            <li>
              4.4. По закінченню надання Послуг Виконавець надає Замовнику два примірники Акту приймання-передачі
              наданих послуг, які Замовник повинен підписати та повернути один примірник Виконавцеві протягом 10
              (десяти) календарних днів з дня їх отримання.
            </li>
            <li>
              4.5. Підписання Акту здачі-приймання наданих послуг представником Замовника є підтвердженням належного
              надання послуг і відсутності претензій з його боку до Виконавця.
            </li>
            <li>
              4.6. Якщо під час приймання-передачі наданих Послуг буде виявлена їх невідповідність вимогам цього
              Договору, вимогам відповідного технічного завдання тощо, Замовник у строк, передбачений п. 4.3. Договору,
              надає Виконавцеві вмотивовану відмову від підписання Акту приймання-передачі наданих послуг із зазначенням
              переліку необхідних доопрацювань і строку їх усунення.
            </li>
            <li>
              4.7. В Акті приймання-передачі зазначається конкретний перелік, тривалість та вартість наданих Послуг.
            </li>
          </ul>
          <h3>5. ПРАВА ТА ОБОВ’ЯЗКИ СТОРІН</h3>
          <p>5.1. Замовник зобов‘язаний:</p>
          <ul>
            <li>
              5.1.1. Надати Виконавцеві всю необхідну інформацію, документацію та інше для надання Послуг за цим
              Договором.
            </li>
            <li>
              5.1.2. Прийняти та оплатити належним чином надані Виконавцем Послуги в порядку та на умовах, передбачених
              Договором.
            </li>
            <li>
              5.1.3. Замовник може нести інші обов‘язки, передбачені цим Договором та/або чинним законодавством України.
            </li>
          </ul>
          <p> 5.2. Замовник має право:</p>
          <ul>
            <li>
              5.2.1. Перевіряти хід і якість Послуг, що надаються за цим Договором, не втручаючись в діяльність
              Виконавця.
            </li>
            <li>
              5.2.2. Замовник може мати інші права, передбачені цим Договором та/або чинним законодавством України.
            </li>
          </ul>
          <p>5.3. Виконавець зобов‘язаний:</p>
          <ul>
            <li>
              5.3.1. Надавати Послуги за цим Договором якісно, своєчасно, належним чином, в порядку та на умовах,
              передбачених Договором.
            </li>
            <li>
              5.3.2. У встановлений цим Договором строк надавати Замовнику Акти приймання-передачі наданих послуг,
              складені у відповідності до вимог цього Договору.
            </li>
            <li>
              5.3.3. На письмову та/або усну вимогу Замовника негайно інформувати Замовника про хід надання Послуг.
            </li>
            <li>
              5.3.4. Не передавати будь-яким третім особам, не оприлюднювати та не використовувати у власних цілях (в
              тому числі, але не обмежуючись, у своїй підприємницькій діяльності) всю та будь-яку інформацію про
              Замовника, умови цього Договору, Послуги, що надаються за цим Договором тощо, яка була одержана у зв‘язку
              та/або під час укладання та/або виконання цього Договору.
            </li>
            <li>
              5.3.5. Протягом трьох календарних днів з дня завершення надання відповідних Послуг повернути Замовнику все
              одержане від останнього для надання таких Послуг, а саме: будь-яке майно, в тому числі технічні засоби,
              апаратуру, обладнання тощо, документацію, інформацію тощо.
            </li>
            <li>
              5.3.6. Дотримуватись вимог чинного законодавства України в сфері охорони прав інтелектуальної власності.
            </li>
            <li>
              5.3.7. Відшкодовувати завдані Замовнику збитки в повному обсязі відповідно до вимог чинного законодавства
              України та цього Договору.
            </li>
            <li>
              5.3.9. Виконавець може нести інші обов‘язки, передбачені цим Договором та/або чинним законодавством
              України.
            </li>
          </ul>
          <p>5.4. Виконавець має право:</p>
          <ul>
            <li>5.4.1. На своєчасну та повну оплату належним чином наданих Послуг.</li>
            <li>
              5.4.2. Виконавець може мати інші права, передбачені цим Договором та/або чинним законодавством України.
            </li>
          </ul>
          <h3>6. ВІДПОВІДАЛЬНІСТЬ СТОРІН.</h3>
          <ul>
            <li>
              6.1. За невиконання та/або неналежне виконання своїх обов‘язків за цим Договором Сторони несуть
              відповідальність, визначену Договором та чинним законодавством України.
            </li>
            <li>
              6.2. За несвоєчасну оплату належним чином наданих Послуг Замовник сплачує на користь Виконавця пеню у
              розмірі подвійної облікової ставки НБУ, що діяла в період, за який сплачується пеня, від несвоєчасно
              сплаченої суми за кожен день затримки розрахунків.
            </li>
            6.3. Сторона, що порушила свої зобов‘язання за цим Договором, відшкодовує іншій Стороні збитки, завдані
            таким порушенням, в повному обсязі, включаючи упущену вигоду.
            <li>6.4. Збитки за цим Договором відшкодовуються понад сплату санкцій.</li>
            <li>
              6.5. Сплата санкцій та/або відшкодування збитків не звільняє Сторони від виконання своїх зобов‘язань за
              Договором.
            </li>
          </ul>
          <h3>7. ЗБЕРЕЖЕННЯ КОМЕРЦІЙНОЇ ТАЄМНИЦІ ТА КОНФІДЕНЦІЙНОЇ ІНФОРМАЦІЇ.</h3>
          <ul>
            <li>
              7.1. Сторони зобов'язуються не передавати третім особам конфіденційну інформацію, до якої вони віднесли
              будь-яку інформацію про їхню діяльність, умови цього Договору, Послуги, що надаються за цим Договором
              тощо, отриману при укладенні та виконанні цього Договору або у зв‘язку з цим.
            </li>
            <li>
              7.2. Сторони домовились, що текст Договору (крім випадків, прямо передбачених чинним законодавством
              України), вихідні дані для надання Послуг та результати наданих Послуг, будь-які дані та інформація,
              документація, що передані Виконавцю та/або створені Виконавцем при виконанні Договору, виражені у формі:
              документ, інформація тощо є конфіденційними та складають комерційну таємницю Замовника та за будь-яких
              умов не підлягає розголошенню Виконавцем. Передача Стороною третім особам даних, що складають
              конфіденційну інформацію, дозволяється лише зі згоди іншої Сторони, за винятком випадків, коли вимога про
              її надання пред'явлена компетентним органом у відповідності до чинного законодавства України.
            </li>
            <li>
              7.3. Умови про не передання конфіденційної інформації зберігають свою силу протягом строку дії Договору.
            </li>
            <li>
              7.4. Інформація не вважається конфіденційною, якщо вона відповідає хоча б одній із таких умов: - вже була
              відома Виконавцеві до укладання Договору; - отримана легально від третьої особи поза зв’язком з цим
              Договором; - розкрита публічно самим Замовником; - розкрита за обґрунтованою письмовою вимогою державного
              органу, повноваження якого щодо отримання такої інформації, визначені чинним законодавством України; -
              дозволена до розповсюдження з письмової згоди Замовника.
            </li>
            <li>
              7.5. У кожному зазначеному у п. 7.4 Договору випадку Виконавець повинен надати Замовнику письмові
              пояснення по кожному випадку оприлюднення, передачі чи витоку інформації з документальним підтвердженням
              правомірності своїх дій протягом 10 (десяти) календарних днів з дня надходження письмового запиту від
              Замовника.
            </li>
            <li>
              7.6. Виконавець гарантує збереження конфіденційності особисто. Відомості, що складають комерційну таємницю
              в будь-якій формі, можуть бути передані третім особам винятково за попередньою письмовою згодою Замовника.
            </li>
            <li>
              7.7. У випадку залучення Виконавцем до надання Послуг третіх осіб, він гарантує, що з переданою
              документацією та інформацією будуть ознайомлені тільки ті особи, що безпосередньо пов'язані із наданням
              Послуг за Договором. Перелік таких осіб погоджується Виконавцем із Замовником.
            </li>
            <li>
              7.8. У випадку розголошення Виконавцем та/або залученими ним до виконання цього Договору третіми особами,
              їхніми працівниками конфіденційної інформації та/або комерційної таємниці, Виконавець зобов‘язується
              відшкодувати Замовнику всі завдані таким розголошенням збитки в повному обсязі , а також сплатити
              передбачену статтею 7 цього Договору.
            </li>
          </ul>
          <h3>8. ФОРС-МАЖОР.</h3>
          <ul>
            <li>
              8.1. Сторони звільняються від відповідальності за часткове та/або повне невиконання зобов’язань за
              Договором, якщо воно є наслідком обставин непереборної сили та/або їх наслідків, а саме: пожежі, повені,
              землетрусу, диверсії, військових дій та/або зміни законодавства, якщо ці обставини та/або їх наслідки
              безпосередньо вплинули на виконання договірних зобов'язань Сторонами. При цьому строк виконання
              зобов'язань продовжується на час, протягом якого діяли такі обставини.
            </li>
            <li>
              8.2. Якщо обставини непереборної сили та/або їх наслідки будуть тривати більше тридцяти календарних днів,
              то кожна зі Сторін має право в односторонньому порядку розірвати Договір, і в цьому випадку жодна із
              Сторін не матиме права на відшкодування збитків.
            </li>
            <li>
              8.3. Сторона, яка не в змозі виконати свої зобов'язання за Договором внаслідок дії обставин непереборної
              сили та/або їх наслідків, зобов'язана негайно письмово повідомити іншу Сторону про початок і припинення
              дії зазначених обставин та/або їх наслідків, підтвердивши довідками компетентних органів країни, в якій
              обставини непереборної сили та/або їх наслідки мали місце, але в будь-якому випадку не пізніше 10 (десяти)
              календарних днів з дня їх виникнення. Несвоєчасне повідомлення про обставини непереборної сили та/або їх
              наслідки позбавляє відповідну Сторону права на звільнення від зобов'язань за Договором з причини
              зазначених обставин та/або їх наслідків.
            </li>
          </ul>
          <h3>9. ВИРІШЕННЯ СПОРІВ.</h3>
          <ul>
            <li>
              9.1. Усі спори, що виникають з цього Договору або пов'язані із ним, вирішуються шляхом переговорів між
              Сторонами.
            </li>
            <li>
              9.2. Якщо відповідний спір неможливо вирішити шляхом переговорів, він вирішується в судовому порядку за
              встановленою підвідомчістю та підсудністю такого спору відповідно до чинного законодавства України.
            </li>
          </ul>
          <h3>10. СТРОК ДІЇ ДОГОВОРУ.</h3>
          <ul>
            <li>10.1. Цей Договір набирає чинності з дня його підписання Сторонами і діє до «» 20 року.</li>
            <li>
              10.2. Строк дії Договору може бути продовжений на наступний календарний рік, якщо жодна Сторона не
              повідомила про його припинення іншу Сторону за 30 (тридцять) календарних днів до закінчення строку дії
              Договору.
            </li>
            <li>10.3. Договір може бути припинений за згодою Сторін.</li>
            <li>
              10.4. У випадку припинення Договору з будь-яких підстав, в тому числі через закінчення строку дії
              Договору, дострокове розірвання тощо, Виконавець зобов’язаний повернути Замовнику все обладнання,
              матеріали та інше майно (або грошові кошти), отримані для надання Послуг за цим Договором. Електронні
              копії (примірники) документації, які так чи інакше використовувались для надання Послуг за цим Договором,
              що містяться на електронних носіях, що належать Виконавцеві, Виконавець зобов‘язаний знищити протягом
              трьох календарних днів з дня припинення Договору.
            </li>
            <li>
              10.5. Кожна із Сторін має розірвати Договір в односторонньому порядку, сповістивши про це одна одну
              письмово за 30 (тридцять) календарних днів до дня розірвання Договору.
            </li>
          </ul>
          <h3>11. ІНШІ УМОВИ.</h3>
          <ul>
            <li>
              11.1. Сторона несе повну відповідальність за правильність вказаних нею у цьому Договорі реквізитів та
              інших даних і зобов'язується протягом 10 (десяти) календарних днів з дня їх зміни у письмовій формі
              повідомляти іншу Сторону про таку зміну, а у разі неповідомлення несе ризик настання пов'язаних із цим
              несприятливих наслідків.
            </li>
            <li>
              11.2. Після укладення цього Договору всі попередні переговори за ним, листування, попередні договори,
              протоколи про наміри та будь-які інші усні або письмові домовленості Сторін з питань, що так чи інакше
              стосуються цього Договору, втрачають юридичну силу.
            </li>
            <li>
              11.3. Зміни до цього Договору можуть бути внесені за взаємною згодою Сторін, що оформляється Додатковою
              угодою до цього Договору.
            </li>
            <li>
              11.4. Додаткові угоди та Додатки до цього Договору є його невід'ємними частинами і мають юридичну силу у
              випадку, якщо вони викладені у письмовій формі та підписані Сторінами.
            </li>
            <li>
              11.5. Недійсність окремих положень цього Договору не тягне недійсність Договору в цілому, оскільки можна
              припустити, що цей Договір міг би бути укладений без включення до нього таких положень.
            </li>
            <li>
              11.6. Назви розділів цього Договору використовуються лише для зручності та жодним чином не впливають на їх
              зміст і тлумачення.
            </li>
            <li>11.7. Замовник є платником єдиного податку.</li>
            <li>11.8. Виконавець є платником єдиного податку.</li>
            <li>
              11.9. Цей Договір складений при повному розумінні Сторонами його умов та термінології українською мовою у
              двох автентичних примірниках, які мають однакову юридичну силу, - по одному для кожної із Сторін.
            </li>
            <li>11.10. Підписання цього Договору є свідченням повного розуміння Сторонами його предмету та умов.</li>
          </ul>
        </div>
      );
  }
  return (
    <div style={{ margin: 10 }}>
      <h1>Terms and Conditions</h1>

      <p>Last updated: June 16, 2019</p>

      <p>
        These Terms and Conditions ("Terms", "Terms and Conditions") govern your relationship with
        https://www.voopty.com/ website (the "Service") operated by Voopty ("us", "we", or "our").
      </p>

      <p>Please read these Terms and Conditions carefully before using the Service.</p>

      <p>
        Your access to and use of the Service is conditioned on your acceptance of and compliance with these Terms.
        These Terms apply to all visitors, users and others who access or use the Service.
      </p>

      <p>
        By accessing or using the Service you agree to be bound by these Terms. If you disagree with any part of the
        terms then you may not access the Service.
      </p>

      <h2>Subscriptions</h2>

      <p>
        Some parts of the Service are billed on a subscription basis ("Subscription(s)"). You will be billed in advance
        on a recurring and periodic basis ("Billing Cycle"). Billing cycles are set on a monthly basis.
      </p>

      <p>
        At the end of each Billing Cycle, your Subscription will automatically renew under the exact same conditions
        unless you cancel it or Voopty cancels it. You may cancel your Subscription renewal either through your online
        account management page or by contacting Voopty customer support team.
      </p>

      <p>
        A valid payment method, including credit card, is required to process the payment for your Subscription. You
        shall provide Voopty with accurate and complete billing information including full name, address, state, zip
        code, telephone number, and a valid payment method information. By submitting such payment information, you
        automatically authorize Voopty to charge all Subscription fees incurred through your account to any such payment
        instruments.
      </p>

      <p>
        Should automatic billing fail to occur for any reason, Voopty will issue an electronic invoice indicating that
        you must proceed manually, within a certain deadline date, with the full payment corresponding to the billing
        period as indicated on the invoice.
      </p>

      <h2>Free Trial</h2>

      <p>
        Voopty may, at its sole discretion, offer a Subscription with a free trial for a limited period of time ("Free
        Trial").
      </p>

      <p>You may be required to enter your billing information in order to sign up for the Free Trial.</p>

      <p>
        If you do enter your billing information when signing up for the Free Trial, you will not be charged by Voopty
        until the Free Trial has expired. On the last day of the Free Trial period, unless you cancelled your
        Subscription, you will be automatically charged the applicable Subscription fees for the type of Subscription
        you have selected.
      </p>

      <p>
        At any time and without notice, Voopty reserves the right to (i) modify the terms and conditions of the Free
        Trial offer, or (ii) cancel such Free Trial offer.
      </p>

      <h2>Fee Changes</h2>

      <p>
        Voopty, in its sole discretion and at any time, may modify the Subscription fees for the Subscriptions. Any
        Subscription fee change will become effective at the end of the then-current Billing Cycle.
      </p>

      <p>
        Voopty will provide you with a reasonable prior notice of any change in Subscription fees to give you an
        opportunity to terminate your Subscription before such change becomes effective.
      </p>

      <p>
        Your continued use of the Service after the Subscription fee change comes into effect constitutes your agreement
        to pay the modified Subscription fee amount.
      </p>

      <h2>Refunds</h2>

      <p>Except when required by law, paid Subscription fees are non-refundable.</p>

      <h2>Content</h2>

      <p>
        Our Service allows you to post, link, store, share and otherwise make available certain information, text,
        graphics, videos, or other material ("Content"). You are responsible for the Content that you post to the
        Service, including its legality, reliability, and appropriateness.
      </p>

      <p>
        By posting Content to the Service, you grant us the right and license to use, modify, publicly perform, publicly
        display, reproduce, and distribute such Content on and through the Service. You retain any and all of your
        rights to any Content you submit, post or display on or through the Service and you are responsible for
        protecting those rights. You agree that this license includes the right for us to make your Content available to
        other users of the Service, who may also use your Content subject to these Terms.
      </p>

      <p>
        You represent and warrant that: (i) the Content is yours (you own it) or you have the right to use it and grant
        us the rights and license as provided in these Terms, and (ii) the posting of your Content on or through the
        Service does not violate the privacy rights, publicity rights, copyrights, contract rights or any other rights
        of any person.
      </p>

      <h2>Accounts</h2>

      <p>
        When you create an account with us, you must provide us information that is accurate, complete, and current at
        all times. Failure to do so constitutes a breach of the Terms, which may result in immediate termination of your
        account on our Service.
      </p>

      <p>
        You are responsible for safeguarding the password that you use to access the Service and for any activities or
        actions under your password, whether your password is with our Service or a third-party service.
      </p>

      <p>
        You agree not to disclose your password to any third party. You must notify us immediately upon becoming aware
        of any breach of security or unauthorized use of your account.
      </p>

      <p>
        You may not use as a username the name of another person or entity or that is not lawfully available for use, a
        name or trade mark that is subject to any rights of another person or entity other than you without appropriate
        authorization, or a name that is otherwise offensive, vulgar or obscene.
      </p>

      <h2>Copyright Policy</h2>

      <p>
        We respect the intellectual property rights of others. It is our policy to respond to any claim that Content
        posted on the Service infringes the copyright or other intellectual property infringement ("Infringement") of
        any person.
      </p>

      <p>
        If you are a copyright owner, or authorized on behalf of one, and you believe that the copyrighted work has been
        copied in a way that constitutes copyright infringement that is taking place through the Service, you must
        submit your notice in writing to the attention of "Copyright Infringement" of support@voopty.com and include in
        your notice a detailed description of the alleged Infringement.
      </p>

      <p>
        You may be held accountable for damages (including costs and attorneys' fees) for misrepresenting that any
        Content is infringing your copyright.
      </p>

      <h2>Intellectual Property</h2>

      <p>
        The Service and its original content (excluding Content provided by users), features and functionality are and
        will remain the exclusive property of Voopty and its licensors. The Service is protected by copyright,
        trademark, and other laws of both the United States and foreign countries. Our trademarks and trade dress may
        not be used in connection with any product or service without the prior written consent of Voopty.
      </p>

      <h2>Links To Other Web Sites</h2>

      <p>
        Our Service may contain links to third-party web sites or services that are not owned or controlled by Voopty.
      </p>

      <p>
        Voopty has no control over, and assumes no responsibility for, the content, privacy policies, or practices of
        any third party web sites or services. You further acknowledge and agree that Voopty shall not be responsible or
        liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with
        use of or reliance on any such content, goods or services available on or through any such web sites or
        services.
      </p>

      <p>
        We strongly advise you to read the terms and conditions and privacy policies of any third-party web sites or
        services that you visit.
      </p>

      <h2>Termination</h2>

      <p>
        We may terminate or suspend your account immediately, without prior notice or liability, for any reason
        whatsoever, including without limitation if you breach the Terms.
      </p>

      <p>
        Upon termination, your right to use the Service will immediately cease. If you wish to terminate your account,
        you may simply discontinue using the Service.
      </p>

      <h2>Limitation Of Liability</h2>

      <p>
        In no event shall Voopty, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable
        for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of
        profits, data, use, goodwill, or other intangible losses, resulting from (i) your access to or use of or
        inability to access or use the Service; (ii) any conduct or content of any third party on the Service; (iii) any
        content obtained from the Service; and (iv) unauthorized access, use or alteration of your transmissions or
        content, whether based on warranty, contract, tort (including negligence) or any other legal theory, whether or
        not we have been informed of the possibility of such damage, and even if a remedy set forth herein is found to
        have failed of its essential purpose.
      </p>

      <h2>Disclaimer</h2>

      <p>
        Your use of the Service is at your sole risk. The Service is provided on an "AS IS" and "AS AVAILABLE" basis.
        The Service is provided without warranties of any kind, whether express or implied, including, but not limited
        to, implied warranties of merchantability, fitness for a particular purpose, non-infringement or course of
        performance.
      </p>

      <p>
        Voopty its subsidiaries, affiliates, and its licensors do not warrant that a) the Service will function
        uninterrupted, secure or available at any particular time or location; b) any errors or defects will be
        corrected; c) the Service is free of viruses or other harmful components; or d) the results of using the Service
        will meet your requirements.
      </p>

      <h2>Governing Law</h2>

      <p>
        These Terms shall be governed and construed in accordance with the laws of United States, without regard to its
        conflict of law provisions.
      </p>

      <p>
        Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights. If
        any provision of these Terms is held to be invalid or unenforceable by a court, the remaining provisions of
        these Terms will remain in effect. These Terms constitute the entire agreement between us regarding our Service,
        and supersede and replace any prior agreements we might have between us regarding the Service.
      </p>

      <h2>Changes</h2>

      <p>
        We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is
        material we will try to provide at least 30 days notice prior to any new terms taking effect. What constitutes a
        material change will be determined at our sole discretion.
      </p>

      <p>
        By continuing to access or use our Service after those revisions become effective, you agree to be bound by the
        revised terms. If you do not agree to the new terms, please stop using the Service.
      </p>

      <h2>Contact Us</h2>

      <p>If you have any questions about these Terms, please contact us.</p>
    </div>
  );
});
